import produce from 'immer';
import { Actions } from './action';
import { AppAction, ProviderType } from './enum';
import { AppState } from './interface';
import { handleProviderChange, handleSetAvailableRouters, handleSetRouters } from './util/reducer';

export const initialState: AppState = {
    isLoading: false,
    error: undefined,
    customer: undefined,
    selectedId: '',
    disableBooking: false,
    providerType: ProviderType.UM,
    routers: {
        UM: [],
        VKD: [],
    },
    availableRouterIds: [
        'homebox5',
        'homebox6',
        'homebox5-um',
        'homebox6-um',
    ],
};

const reducer = (state: AppState = initialState, action: Actions) =>
    produce(state, (draft) => {
        switch (action.type) {
            case AppAction.INIT_STORE:
                draft.selectedId = action.state.selectedId ?? draft.selectedId;
                draft.providerType = action.state.providerType ?? draft.providerType;
                draft.availableRouterIds = action.state.availableRouterIds ?? draft.availableRouterIds;
                break;
            case AppAction.SET_LOADING:
                draft.isLoading = action.isLoading;
                break;
            case AppAction.SET_ERROR:
                draft.error = action.error;
                draft.isLoading = false;
                break;
            case AppAction.SET_SELECTED_ROUTER:
                draft.selectedId = action.selectedId;
                break;
            case AppAction.SET_AVAILABLE_ROUTER_IDS:
                handleSetAvailableRouters(draft, action.routerIds);
                break;
            case AppAction.SET_PROVIDER_TYPE:
                handleProviderChange(draft, action.providerType);
                break;
            case AppAction.SET_ROUTERS:
                handleSetRouters(draft, action.routers);
                break;
            case AppAction.SET_CUSTOMER:
                draft.customer = action.customer;
                break;
            case AppAction.SET_DISABLE_BOOKING:
                draft.disableBooking = action.disableBooking;
                break;
            case AppAction.SET_PUBLIC_FACT_NAME:
                draft.publicFactName = action.publicFactName;
                break;
            case AppAction.SET_CUSTOMER_TYPE:
                draft.customerType = action.customerType;
                break;
        }
    });

export default reducer;
